import TimelineLite from 'gsap/TimelineLite';
import BaseComponent from '../../../general/js/base-component';

export default class AuthFormsComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.loginForm = this.refs.loginForm;
        this.forgotPasswordForm = this.refs.forgotPasswordForm;
        this.showForgotPasswordTrigger = this.refs.showForgotPasswordTrigger;
        this.showLoginTrigger = this.refs.showLoginTrigger;

        this.forgotPasswordTriggerClick = this.forgotPasswordTriggerClick.bind(this);
        this.loginTriggerClick = this.loginTriggerClick.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['loginForm', 'forgotPasswordForm', 'showForgotPasswordTrigger', 'showLoginTrigger'];
    }

    init() {
        this.tween = new TimelineLite({paused: true});
        this.tween.to(this.loginForm, 0.3, {opacity: 0, display: 'none'});
        this.tween.to(this.forgotPasswordForm, 0.3, {opacity: 1, display: 'flex'});

        this.showForgotPasswordTrigger.addEventListener('click', this.forgotPasswordTriggerClick);
        this.showLoginTrigger.addEventListener('click', this.loginTriggerClick);
    }

    forgotPasswordTriggerClick() {
        this.tween.play();
    }

    loginTriggerClick() {
        this.tween.reverse();
    }

    onDestroy() {
        this.tween = null;
        this.showForgotPasswordTrigger.removeEventListener('click', this.forgotPasswordTriggerClick);
        this.showLoginTrigger.removeEventListener('click', this.loginTriggerClick);
    }
}



// WEBPACK FOOTER //
// ./app/components/auth-forms/js/auth-forms.component.js